import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import { createUser, getClients, getUserTypes } from "../../../../API/swesum";
import { Collapse, InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import usePost from "Hooks/usePost";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function CreateUserForm() {
  const { openError } = usePopupNotificationContext();
  const navigate = useNavigate();
  const [userTypes, setUserTypes] = useState([]);
  const [clients, setClients] = useState([]);
  const [inputs, setInputs] = useState(null);

  useEffect(() => {
    const asyncFetchUserTypes = async () => {
      const tmpUserTypes = await getUserTypes();
      const clients = await getClients();
      setClients(clients);
      setUserTypes(tmpUserTypes);
      setInputs({
        Username: "",
        Password: "",
        Usertype: tmpUserTypes[0].Value,
        UsertypeId: null,
      });
    };
    asyncFetchUserTypes();
  }, []);

  const postReq = usePost({
    mtnFunc: (inputs) => {
      return createUser(inputs);
    },
    onSuccess: () => {
      navigate("/users");
    },
    onError: (err) => {
      err?.response?.data
        ? openError(err?.response?.data, 10000)
        : openError("Ett fel uppstod när användaren skulle uppdateras.", 10000);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    postReq.post(inputs);
  };

  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  if (!inputs) {
    return null;
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <TextField
              name="Username"
              label="Epost"
              size="small"
              fullWidth
              value={inputs.Username}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              name="Password"
              label="Lösenord"
              type="password"
              size="small"
              fullWidth
              value={inputs.Password}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <FormControl fullWidth sx={{ textAlign: "left" }}>
              <InputLabel>Roll</InputLabel>
              <Select
                name="Usertype"
                value={inputs.Usertype}
                label="Role"
                onChange={handleChange}
                size="small"
              >
                {userTypes.map((type) => (
                  <MenuItem key={type.Value} value={type.Value}>
                    {type.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12}>
            <Collapse in={inputs.Usertype === "client"}>
              <FormControl
                required={inputs.Usertype === "client"}
                fullWidth
                sx={{ textAlign: "left" }}
              >
                <InputLabel>Klient</InputLabel>
                <Select
                  name="UsertypeId"
                  value={inputs.UsertypeId}
                  label="Klient"
                  onChange={handleChange}
                  size="small"
                >
                  {clients.map((client) => (
                    <MenuItem key={client.Id} value={client.Id}>
                      {client.Title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Collapse>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 3,
            }}
          >
            <Button onClick={() => navigate(-1)}>Stäng</Button>
            <Button
              sx={{ ml: 3 }}
              disabled={inputs.Password === "" || inputs.Username === ""}
              type={"submit"}
              variant="contained"
            >
              Spara
            </Button>
          </Grid>
        </Grid>
      </form>
      {postReq.loading && <h5>{"Laddar"}</h5>}
      {postReq.error && <h5>{postReq.error.response.statusText}</h5>}
    </>
  );
}
